<template>
  <v-timeline-item :color="getColorObservation()" :icon="getIconObservation()" small>
    <v-layout pt-3>
      <v-flex xs2>
        <strong>{{ observation.created }}</strong>
      </v-flex>
      <v-flex xs10>
        <strong>{{ observation.statusDisplay }} </strong>
        <i> - {{ observation.author.firstName }} {{ observation.author.lastName }}
          <span v-if="observation.author.departamento !== 'None'">({{ observation.author.departamento }})</span></i>
        <v-btn color="green darken-1" class="timeline-button white--text" @click="goCorrectionRoute"
          v-if="hasCorrectionButton()">Corregir</v-btn>
        <div class="text-formatted">{{ observation.text.charAt(0).toUpperCase() + observation.text.slice(1) }}</div>
        <div v-if="observation.fechaTerminacion">
          <div style="display: flex; gap: 8px;">
            <u>Fecha de finalizacion:</u>
            {{ observation.fechaTerminacion }}
            <v-icon v-if="$store.state.permissions.canEditFechaFin && this.lastItem" small color="primary" class="cursor-pointer" @click="openDialog(observation)">
              edit
            </v-icon>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <p style="font-size: 1.5rem; margin-bottom: 0; padding-top: 10px; padding-left: 10px;">
          Editar fecha de finalización de contrato
        </p>
        <p style="padding-left: 10px; font-style: italic">
          Esta acción modificará la fecha de finalización de contrato y las de las condiciones salariales
          correspondientes.
        </p>
        <div style="display: flex; justify-content: center; margin-bottom: 10px;">
          <v-date-picker v-model="selectedDate" locale="es"></v-date-picker>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="guardarFecha">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-timeline-item>
</template>

<script>
import Constants from '../../../common/constants'
const REJECTED = 'Rechazado'

export default {
  props: {
    observation: Object,
    lastItem: Boolean,
    contract: Object
  },
  data () {
    return {
      dialog: false,
      selectedDate: null,
      observationToEdit: null
    }
  },

  computed: {
    correctionRoute () {
      if (this.hasCorrectionButton()) {
        return (this.contract.addenda.length) ? this.getAddendumPath() : this.getContractPath()
      }
      return ''
    }
  },

  methods: {
    getColorObservation () {
      switch (this.observation.status) {
        case Constants.CONTRACT_PENDING:
          return 'yellow darken-3'
        case Constants.CONTRACT_REJECTED:
          return 'red'
        case Constants.CONTRACT_ENDED:
          return 'grey'
        default:
          return 'green'
      }
    },
    getIconObservation () {
      switch (this.observation.status) {
        case Constants.CONTRACT_PENDING:
          return 'pause'
        case Constants.CONTRACT_REJECTED:
          return 'close'
        case Constants.CONTRACT_ENDED:
          return 'fa-slash'
        default:
          return 'done'
      }
    },
    isRefused () {
      return this.contract.status === REJECTED
    },
    hasCorrectionButton () {
      return this.lastItem && this.isRefused() && this.$store.getters.isClubRole && !this.contract.terminations.length
    },
    getAddendumPath () {
      return {
        name: 'editarAdenda',
        params: {
          id: this.contract.pk,
          idAddendum: this.contract.addenda[this.contract.addenda.length - 1].pk,
          extend: this.contract.addenda[this.contract.addenda.length - 1].endDate,
          contractEndDate: this.contract.endDate
        }
      }
    },
    getContractPath () {
      return { name: 'editarContrato', params: { id: this.contract.player.pk, idContract: this.contract.pk } }
    },
    goCorrectionRoute () {
      this.$router.push(this.correctionRoute)
    },
    openDialog (observation) {
      this.observationToEdit = observation
      const rawDate = observation.fechaTerminacion

      if (rawDate) {
        const [day, month, year] = rawDate.split('/')
        this.selectedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        this.selectedDate = null
      }

      this.dialog = true
    },

    guardarFecha () {
      try {
        this.axios.put(`contract/edit-date-finalization`, { fechaFinalizacion: this.selectedDate, contractObservation: this.observation.pk })
          .then(() => {
            this.$router.go()
            this.saving = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      } catch (error) {
        this.dialog = false
        return 0
      }

      this.dialog = false
    }
  }
}

</script>

<style scoped>
.timeline-button {
  height: 22px;
  margin-left: 1.5em;
  margin-top: 0;
}
</style>
